import { render, staticRenderFns } from "./DialogGeneralDashboardDetail.vue?vue&type=template&id=0e75aa03&"
import script from "./DialogGeneralDashboardDetail.vue?vue&type=script&lang=js&"
export * from "./DialogGeneralDashboardDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports